import {taxVatValidator} from "../index";

const checkoutBeneficiaryFormValidator = props => {
    // Destructured props
    const {
        formValues,
        isUnderEighteen = false
    } = props;

    // The regexes for the value to be validated from
    const emailRegex = new RegExp("^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$");
    const dobRegex = /([0-2][0-9]|3[0-1])\/(0[0-9]|1[0-2])\/[0-9]{4}/;
    const taxVatRegex = new RegExp("^\\d{3}\\.\\d{3}\\.\\d{3}\\-\\d{2}$");

    // Actual form field validator for the first step
    const validateForm = props => {
        // Destructured props
        const {
            target,
            value
        } = props;

        let errors = {};

        // Validates each field
        switch (target) {
            case "name":
                if (!value) {
                    errors.name = "Esse campo é obrigatório.";
                } else if (value && value.split(" ").length < 2) {
                    errors.name = "Seu nome deve possuir no mínimo duas palavras.";
                } else {
                    errors.name = "";
                }

                break;
            case "email":
                if (!isUnderEighteen) {
                    if (!value) {
                        errors.email = "Esse campo é obrigatório.";
                    } else if (value && !emailRegex.test(value)) {
                        errors.email = "Insira um endereço de email válido.";
                    } else if (value.endsWith(".co")) {
                        errors.email = "Insira um endereço de email válido.";
                    } else {
                        errors.email = "";
                    }
                } else {
                    errors.email = "";
                }

                break;
            case "birthdate":
                if (!value) {
                    errors.birthdate = "Esse campo é obrigatório.";
                } else if (value && !dobRegex.test(value)) {
                    errors.birthdate = "Insira uma data de nascimento válida.";
                } else {
                    errors.birthdate = "";
                }

                break;
            case "gender": {
                const allowedValues = ['1', '2'];

                if (!allowedValues.includes(value)) {
                    errors.gender = "Esse campo é obrigatório.";
                } else {
                    errors.gender = "";
                }

                break;
            }
            case "cpf":
                if (formValues.isBrazilian && !isUnderEighteen) {
                    if (!value) {
                        errors.cpf = "Esse campo é obrigatório.";
                    } else if (value && (!taxVatRegex.test(value) || !taxVatValidator(value))) {
                        errors.cpf = "Insira um número de CPF válido."
                    } else {
                        errors.cpf = "";
                    }
                } else {
                    errors.cpf = "";
                }

                break;
            case "passport":
                if (!formValues.isBrazilian && !isUnderEighteen) {
                    if (!value) {
                        errors.passport = "Esse campo é obrigatório.";
                    } else {
                        errors.passport = "";
                    }
                } else {
                    errors.passport = "";
                }

                break;
            case "country":
                if (!formValues.isBrazilian) {
                    if (!value) {
                        errors.country = "Esse campo é obrigatório.";
                    } else {
                        errors.country = "";
                    }
                } else {
                    errors.country = "";
                }

                break;
            case "address":
                if (!formValues.isBrazilian) {
                    if (!value) {
                        errors.address = "Esse campo é obrigatório.";
                    } else {
                        errors.address = "";
                    }
                } else {
                    errors.address = "";
                }

                break;
            case "phone":
                if (!formValues.isBrazilian) {
                    if (!value) {
                        errors.phone = "Esse campo é obrigatório.";
                    } else {
                        errors.phone = "";
                    }
                } else {
                    errors.phone = "";
                }

                break;
            case "city":
                if (!formValues.isBrazilian) {
                    if (!value) {
                        errors.city = "Esse campo é obrigatório.";
                    } else {
                        errors.city = "";
                    }
                } else {
                    errors.city = "";
                }

                break;
            case "number":
                if (!formValues.isBrazilian) {
                    if (!value) {
                        errors.number = "Esse campo é obrigatório.";
                    } else {
                        errors.number = "";
                    }
                } else {
                    errors.number = "";
                }

                break;
            case "postalCode":
                if (!formValues.isBrazilian) {
                    if (!value) {
                        errors.postalCode = "Esse campo é obrigatório.";
                    } else {
                        errors.postalCode = "";
                    }
                } else {
                    errors.postalCode = "";
                }

                break;

            // Parental fields validation
            case "responsibleName":
                if (isUnderEighteen) {
                    if (!value) {
                        errors.responsibleName = "Esse campo é obrigatório.";
                    } else if (value && value.split(" ").length < 2) {
                        errors.responsibleName = "Seu nome deve possuir no mínimo duas palavras.";
                    } else {
                        errors.responsibleName = "";
                    }
                } else {
                    errors.responsibleName = "";
                }

                break;
            case "responsibleEmail":
                if (isUnderEighteen) {
                    if (!value) {
                        errors.responsibleEmail = "Esse campo é obrigatório.";
                    } else if (value && !emailRegex.test(value)) {
                        errors.responsibleEmail = "Insira um endereço de email válido.";
                    } else {
                        errors.responsibleEmail = "";
                    }
                } else {
                    errors.responsibleEmail = "";
                }

                break;
            case "responsibleTaxVat":
                if (formValues.isBrazilian && isUnderEighteen) {
                    if (!value) {
                        errors.responsibleTaxVat = "Esse campo é obrigatório.";
                    } else if (value && (!taxVatRegex.test(value) || !taxVatValidator(value))) {
                        errors.responsibleTaxVat = "Insira um número de CPF válido."
                    } else {
                        errors.responsibleTaxVat = "";
                    }
                } else {
                    errors.responsibleTaxVat = "";
                }

                break;
            case "affiliation":
                if (!value) {
                    errors.affiliation = "Esse campo é obrigatório.";
                } else if (value && value.split(" ").length < 2) {
                    errors.affiliation = "O nome deve possuir no mínimo duas palavras.";
                } else {
                    errors.affiliation = "";
                }
                
                break;
            case "responsiblePassport":
                if (!formValues.isBrazilian && isUnderEighteen) {
                    if (!value) {
                        errors.responsiblePassport = "Esse campo é obrigatório.";
                    } else {
                        errors.responsiblePassport = "";
                    }
                } else {
                    errors.responsiblePassport = "";
                }

                break;
            default:
                return errors;
        }

        return errors;
    }

    // Method to perform a validation in all fields at once
    const validateAll = () => {
        let errors = {};

        // Iterates through each field validating them
        Object.keys(formValues).forEach(key => {
            const args = {
                target: key,
                value: formValues[key]
            }

            errors = {
                ...errors,
                ...validateForm(args)
            }
        })

        // Returns the errors object to be set into the error state
        return errors;
    }

    return {
        validateForm,
        validateAll
    }
}

export default checkoutBeneficiaryFormValidator;
